import { useState } from 'react';
import { redirectToCustomerPortal } from '../utils';
import { getCookie } from 'cookies-next';
import {
  cookiesFavoriteListings,
  cookiesIdToken,
  setCrossDomainCookie,
  toggleFavoriteListings,
} from '@requity-homes/utils';
import { Listing } from '../graphql/generated';

const idToken = getCookie(cookiesIdToken);

export function useFavoriteButtonClick() {
  const [isLoading, setIsLoading] = useState(false);
  const [favoriteListingIds, setFavoriteListingIds] = useState([]);

  const toggleListings = async (listing: Listing) => {
    setIsLoading(true);
    const listingIds = await toggleFavoriteListings(listing, idToken);
    if (listingIds) {
      setCrossDomainCookie(cookiesFavoriteListings, JSON.stringify(listingIds));
      setFavoriteListingIds(listingIds);
    } else {
      // Null was returned. Auth error must have occured
      redirectToCustomerPortal();
    }
    setIsLoading(false);
  };

  return {
    isLoading,
    favoriteListingIds,
    setFavoriteListingIds,
    toggleListings,
  };
}
